// Domain Accordion functionality for URL details
// Handles expanding/collapsing domain URL rankings

class DomainAccordion {
  constructor() {
    this.init()
  }

  init() {
    // Event delegation: turbo-frame の lazy load 後に挿入されるボタンにも対応
    document.addEventListener('click', (e) => {
      const button = e.target.closest('.domain-accordion-btn')
      if (!button) return
      e.preventDefault()
      this.toggleDomainDetails(button)
    })
  }

  toggleDomainDetails(button) {
    const domain = button.getAttribute('data-domain')
    const domainIndex = button.getAttribute('data-domain-index')
    
    // Find the details row for this domain
    const detailsRow = document.querySelector(`.domain-details-row[data-domain="${domain}"]`)
    const chevronIcon = button.querySelector('.iconify')
    
    if (!detailsRow) {
      console.error('Details row not found for domain:', domain)
      return
    }

    const isExpanded = !detailsRow.classList.contains('hidden')
    
    if (isExpanded) {
      // Collapse
      detailsRow.classList.add('hidden')
      chevronIcon.classList.remove('lucide--chevron-up')
      chevronIcon.classList.add('lucide--chevron-down')
      detailsRow.style.display = 'none'
    } else {
      // Expand
      detailsRow.classList.remove('hidden')
      chevronIcon.classList.remove('lucide--chevron-down')
      chevronIcon.classList.add('lucide--chevron-up')
      detailsRow.style.display = 'table-row'
      
      // Load URL data if not already loaded
      this.loadDomainUrls(domain, detailsRow)
    }
  }

  loadDomainUrls(domain, detailsRow) {
    const urlsBody = detailsRow.querySelector('.domain-urls-body')
    
    // Check if data is already loaded (not showing loading spinner)
    if (!urlsBody.querySelector('.loading')) {
      return // Data already loaded
    }

    // Get URL data from JSON script tag
    const jsonScript = document.querySelector(`script[data-domain-urls="${domain}"]`)
    const urlsData = jsonScript ? JSON.parse(jsonScript.textContent || '[]') : []
    
    // Simulate brief loading delay for UX
    setTimeout(() => {
      this.renderDomainUrls(domain, urlsBody, urlsData)
    }, 200)
  }

  renderDomainUrls(domain, urlsBody, urlsData = []) {
    // Sort URLs by count in descending order
    const sortedUrls = urlsData.sort((a, b) => b.count - a.count)
    
    // Clear loading spinner
    urlsBody.innerHTML = ''
    
    // Render URL rankings
    sortedUrls.slice(0, 10).forEach((urlData, index) => {
      const row = document.createElement('tr')
      row.innerHTML = `
        <td class="w-12">
          <span class="text-xs font-bold">${index + 1}</span>
        </td>
        <td class="text-xs">
          <a href="${urlData.url}" target="_blank" class="link link-primary truncate max-w-xs block" title="${urlData.url}">
            ${urlData.url}
          </a>
        </td>
        <td class="w-16 text-xs">
          ${this.numberWithDelimiter(urlData.count)}
        </td>
      `
      urlsBody.appendChild(row)
    })

    // Show "no data" message if no URLs found
    if (sortedUrls.length === 0) {
      urlsBody.innerHTML = `
        <tr>
          <td colspan="3" class="text-center text-base-content/50 text-xs">
            <span class="iconify lucide--info size-3 mr-1"></span>
            URL データが見つかりません
          </td>
        </tr>
      `
    }
  }


  numberWithDelimiter(number) {
    return number.toLocaleString()
  }
}

// Auto-initialize
new DomainAccordion()
